export const saveCampaignIdCookie = () => {
  if (typeof window === 'undefined') {
    return
  }

  const cidParam = getParamValue('CID')

  if (cidParam) {
    document.cookie = `cid:servicing=${cidParam};path=/`

    return
  }

  return
}

export const getCampaignIdCookie = () => {
  if (typeof window === 'undefined') {
    return
  }

  return getCookie('cid:servicing')
}

const getParamValue = (param: string): string | null => {
  if (!window.location) {
    return null
  }

  const params = window.location?.search
  const searchParams = new URLSearchParams(params)

  return searchParams.get(param)
}

const getCookie = (name: string): string | undefined =>
  document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`)?.pop()
